import SVTAPI from './svtapi';
import $ from 'jquery';

class WebshopUser extends SVTAPI {
  /**
   * Initializes a new, existing user.
   *
   * @param {string} pid The pid of the user
   */
  constructor(pid) {
    super('/webshopuser');
    this._pid = pid;
  }

  /**
   * PATCH /webshopuser/:pid
   * Edits a user's details
   *
   * @param {Object} data - The new user details, e.g. { ssn_confirmed: true }
   * @param {Number} [pid] - An eshop user pid can be set here
   * @returns {Object} - The server's response
   */
  patch(data) {
    return super.patch({ url: '/' + this._pid, data });
  }


  /**
   * Checks whether user's ssn in db matches requested ssn
   * NOTE: this queries svt-verkkokauppa API
   *
   * @param {string} ssn - A person's ssn
   *
   * @return {object} - The server's response
   */
  checkSSN(ssn) {
    const url = `https://svt-verkkokauppa.clients.crasman.fi/api/1.0.0/user/${this._pid}/check-ssn/${ssn}/`;

    return this._parseResult($.ajax({
      url: url,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json'
    }));
  }
}

export default WebshopUser;
